import { createPortal } from 'react-dom'
import { useToast } from './ToastContext'
import { Toast } from './Toast'
import styles from './ToastContainer.module.scss'

export const ToastContainer = () => {
  const { toasts, closeToast } = useToast()

  if (toasts.length === 0) return null

  return createPortal(
    <div className={styles.container}>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={closeToast} />
      ))}
    </div>,
    document.body
  )
}
